import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { userAtom } from '../state/atoms/authAtoms';
import { ScenarioPerformance } from '../types/models/scenarioPerformance';
import { RawScenarioPerformance } from '../types/api/scenario';
import { getScenarioPerformance } from '../services/ShootingData/service';
import { toScenarioPerformances } from '../adapters/scenarioAdapter';
import { UserStatistics } from '../types/ui/userStatistics';



export function useScenarioPerformance(
  sessionId?: number,
  stats?: UserStatistics
): UseQueryResult<ScenarioPerformance[], Error> {
  const currentUser = useAtomValue(userAtom);
  const userId = currentUser?.user_id;

  return useQuery<ScenarioPerformance[], Error>({
    queryKey: ['scenarioPerformance', userId, sessionId],
    queryFn: async () => {
      const rawArray: RawScenarioPerformance[] = await getScenarioPerformance(
        userId!,
        sessionId!
      );
      return toScenarioPerformances(rawArray, stats);
    },
    enabled: Boolean(userId && sessionId != null),
    staleTime: 5 * 60_000,
    placeholderData: (last) => last ?? [],
  });
}